module.exports = "../css/login.css";


//////////////////
// WEBPACK FOOTER
// ./src/scss/login/login.scss
// module id = 141
// module chunks = 0